var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoTerrainEtudierMarche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_terrain_-_biens_vendus",
    "data-name": "picto terrain - biens vendus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.605,
    height: 13.514,
    viewBox: "0 0 15.605 13.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_406",
    "data-name": "Trac\\xE9 406",
    d: "M15.277,12.873H9.046V10.944h3.208a.321.321,0,0,0,.251-.529l-1.8-2.073h1.151A.331.331,0,0,0,12.1,8.25a.317.317,0,0,0,.1-.229.324.324,0,0,0-.136-.262l-2.182-2.6h1.179a.326.326,0,0,0,.231-.09.312.312,0,0,0,.1-.225.329.329,0,0,0-.12-.257L7.835.128A.332.332,0,0,0,7.377.064a.184.184,0,0,0-.065.064L3.819,4.644a.311.311,0,0,0-.064.238.314.314,0,0,0,.13.211.321.321,0,0,0,.2.064H5.271L3.034,7.829a.316.316,0,0,0,.044.449.343.343,0,0,0,.213.075H4.425l-1.8,2.063a.321.321,0,0,0,.038.454.343.343,0,0,0,.213.075H6.422v1.929H.327a.321.321,0,1,0,0,.641h14.95a.321.321,0,1,0,0-.641Zm-8.184,0v-2.25a.324.324,0,0,0-.327-.321H3.59l1.8-2.073a.316.316,0,0,0-.033-.454A.343.343,0,0,0,5.14,7.7H3.983L6.22,5.028a.316.316,0,0,0-.044-.454A.326.326,0,0,0,5.969,4.5H4.758L7.568.855l2.8,3.66H9.172a.321.321,0,0,0-.251.529l2.237,2.672H10a.326.326,0,0,0-.231.09.312.312,0,0,0-.1.225.332.332,0,0,0,.076.214l1.8,2.073H8.73a.324.324,0,0,0-.327.321v2.25Z",
    transform: "translate(0 0)",
    fill: "#616a7d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTerrainEtudierMarche);
export default __webpack_public_path__ + "static/media/picto_terrain_etudier_marche.1f93a558.svg";
export { ForwardRef as ReactComponent };